export class PriceConversion {
  constructor() {}
  public id: number;
  public studentprice: number;
  public staffprice: number;
}
